<template>
  <main>
    <v-container>
      <v-toolbar flat class="main-header mb-12">
        <v-toolbar-title class="main-header__title">
          <h1>Edit Order no. {{ wellspring_order_id }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <formWrapper :validator="$v.form">
        <form @submit.prevent="handleSave" class="form-box">
          <v-row>
            <v-col class="py-2" cols="12">
              <form-group
                name="payment_method_id"
                attribute="fields.payment_method_id"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-select
                    :items="payment_methods"
                    item-text="name"
                    item-value="id"
                    regular
                    clearable
                    v-bind="attrs"
                    v-on="listeners"
                    :disabled="Dimmed"
                    v-model="form.payment_method_id.id"
                  ></v-select>
                </template>
              </form-group>
            </v-col>
            <v-col class="py-2" cols="12">
              <form-group name="notes" :attribute="`fields.notes`">
                <template slot-scope="{ attrs, listeners }">
                  <v-textarea
                    v-bind="attrs"
                    v-on="listeners"
                    regular
                    v-model="form.notes"
                  ></v-textarea>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" lg="4" sm="6" class="text-center">
              <v-btn
                class="text-capitalize"
                large
                color="primary"
                type="submit"
                width="100%"
                :disabled="$v.form.$invalid"
                ><span>Submit</span></v-btn
              >
            </v-col>
          </v-row>
        </form></formWrapper
      >
    </v-container>
  </main>
</template>

<script>
import { IndexData, ShowData, StoreData } from "@/helpers/apiMethods";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      payment_methods: [],
      form: {
        order_id: this.$route.params.id,
        payment_method_id: {
          id: "",
          name: ""
        },
        notes: null
      },
      isEdited: false,
      Dimmed: false,
      wellspring_order_id: ""
    };
  },
  methods: {
    indexPaymentMethods() {
      IndexData({ reqName: `/lists` })
        .then(res => {
          this.payment_methods = res.data.payment_methods;
        })
        .catch(() => {})
        .finally(() => {});
    },
    showOrder(id) {
      ShowData({
        reqName: `order/show`,
        id
      })
        .then(res => {
          this.form = res.data.bookings;
          this.form.order_id = res.data.bookings.id;
          if (res.data.bookings.can_edit_payment_method == false) {
            this.Dimmed = true;
          }
          if (res.data.bookings.notes == null) {
            this.form.notes = "";
          }
          this.wellspring_order_id = res.data.bookings.wellspring_order_id;
        })
        .catch(() => {});
    },
    handleSave() {
      const formData = new FormData();

      Object.keys(this.form).forEach(formItem => {
        if (formItem === "payment_method_id") {
          formData.append(formItem, this.form[formItem].id);
        } else if (
          formItem === "id" ||
          formItem === "status" ||
          formItem === "can_edit_payment_method"
        ) {
          return;
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      StoreData({
        reqName: `orders`,
        data: formData
      })
        .then(() => {
          this.$router.push("/bookings");
        })
        .catch(() => {})
        .finally(() => {
          this.reset();
        });
    }
  },
  created() {
    this.indexPaymentMethods();
  },
  watch: {
    $route: {
      handler(route) {
        this.showOrder(route.params.id);
      },
      deep: true,
      immediate: true
    }
  },
  validations: {
    form: {
      payment_method_id: {
        required
      },
      notes: {
        minLength: minLength(3),
        maxLength: maxLength(255)
      }
    }
  }
};
</script>
